import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import QuickRepliesLayer from "../components/QuickRepliesLayer";

const QuickReplies = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Quick Replies" />
      <QuickRepliesLayer />
    </MasterLayout>
  );
};

export default QuickReplies;
